import React, {FC} from "react";
import {RootState} from "../redux/store";
import {ActionCreator, SerializedError} from "@reduxjs/toolkit";
import {useAppDispatch, useAppSelector} from "../redux/redux.hook";
import {Alert, AlertTitle} from "@material-ui/lab";
import {Snackbar} from "@material-ui/core";

interface ErrorAlertProps {
    selector: (state: RootState) => SerializedError | undefined,
    clearAction: ActionCreator<any>
}

export const ErrorAlert: FC<ErrorAlertProps> = (props) => {
    const dispatch = useAppDispatch();

    const handleClearError = () => dispatch(props.clearAction());

    const error = useAppSelector(props.selector);

    return (
        <Snackbar open={Boolean(error)} onClose={handleClearError} anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
        }}>
            <Alert onClose={handleClearError} severity="error">
                <AlertTitle>
                    Error
                </AlertTitle>
                {error?.message}
            </Alert>
        </Snackbar>

    )
}
